import axios from "axios"

export default {
  getAdAccountAudiences(adAccountId) {
    const url = `/fam/adaccounts/${adAccountId}/audiences`

    return axios.get(url).then(response => {
      return response.data
    })
  },

  getAdAccountAudienceDrafts(adAccountId) {
    const url = `/fam/adaccounts/${adAccountId}/audiences-drafts`

    return axios.get(url).then(response => {
      return response.data
    })
  },

  getLookalikeAudienceSources(adAccountId) {
    const url = `/fam/adaccounts/${adAccountId}/audiences/lookalike/sources`

    return axios.get(url).then(response => {
      return response.data
    })
  },

  postAudienceDraft(data) {
    const url = `/fam/audiences-drafts`

    return axios.post(url, data).then(response => {
      return response.data
    })
  },

  patchAudienceDraft(id, data) {
    const url = `/fam/audiences-drafts/${id}`

    return axios.patch(url, data).then(response => {
      return response.data
    })
  },

  publishAudienceDraft(audienceDraftId) {
    const url = `/fam/audiences-drafts/${audienceDraftId}/publish`

    return axios.post(url).then(response => {
      return response.data
    })
  },
}
